document.documentElement.classList.remove('no-js');

(function () {
  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[–—]/g, '-')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mediaMatchesVariant(searchText, variantTitle) {
    var hay = normalize(searchText);
    var title = normalize(variantTitle);
    if (!hay || !title) return false;

    var isTwo = /(^|\s)(2|two|double)(\s|$)/.test(title);
    var isFour = /(^|\s)(4|four)(\s|$)/.test(title);
    var ready = title.indexOf('ready to fish') !== -1;
    var diy = title.indexOf('diy') !== -1 || title.indexOf('rigging') !== -1;
    var hiLo = title.indexOf('hi lo') !== -1;
    var complete = title.indexOf('complete surf rig') !== -1 || (title.indexOf('complete') !== -1 && title.indexOf('surf rig') !== -1);

    var hayTwo = /(^|\s)(2|two|double)(\s|$)/.test(hay) || hay.indexOf('two pack') !== -1 || hay.indexOf('2 pack') !== -1;
    var hayFour = /(^|\s)(4|four)(\s|$)/.test(hay) || hay.indexOf('four pack') !== -1 || hay.indexOf('4 pack') !== -1;
    var hayReady = hay.indexOf('ready to fish') !== -1 || hay.indexOf('rigged and ready') !== -1 || hay.indexOf('ready fish') !== -1;
    var hayNoHook = hay.indexOf('without hook') !== -1 || hay.indexOf('no hook') !== -1 || hay.indexOf('unrigged') !== -1 || hay.indexOf('diy') !== -1;
    var hayHiLo = hay.indexOf('hi lo') !== -1 || hay.indexOf('high low') !== -1;
    var hayComplete = hay.indexOf('complete surf rig') !== -1 || (hay.indexOf('complete') !== -1 && hay.indexOf('surf rig') !== -1);

    if (complete) return hayComplete;
    if (hiLo) return hayHiLo;
    if (ready && /(^|\s)(1|one|single)(\s|$)/.test(title)) return hayReady && /(^|\s)(1|one|single)(\s|$)/.test(hay);
    if (ready && isTwo) return hayReady && hayTwo;
    if (ready && isFour) return hayReady && hayFour;
    if (diy && isTwo) return hayNoHook && hayTwo;
    if (diy && isFour) return hayNoHook && hayFour;

    // Generic fallback: require the meaningful words from the variant title.
    var ignored = { pack:1, rig:1, rigging:1, sandspawn:1, ready:1, fish:1, diy:1 };
    var words = title.split(' ').filter(function (word) { return word.length > 2 && !ignored[word]; });
    if (!words.length) return false;
    return words.every(function (word) { return hay.indexOf(word) !== -1; });
  }

  function initProductGallery(root) {
    var mainImage = root.querySelector('[data-gallery-main] img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var fullLink = root.querySelector('[data-gallery-full-link]');
    var hint = root.querySelector('[data-gallery-hint]');
    if (!mainImage || !thumbs.length) return function () {};

    function activate(thumb) {
      if (!thumb) return;
      thumbs.forEach(function (item) {
        var active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      mainImage.src = thumb.dataset.fullSrc;
      if (thumb.dataset.fullSrcset) mainImage.srcset = thumb.dataset.fullSrcset;
      mainImage.alt = thumb.dataset.alt || '';
      if (fullLink) fullLink.href = thumb.dataset.fullSrc;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activate(thumb); });
    });

    return function (option) {
      if (!option) return;
      var variantTitle = option.dataset.variantTitle || option.textContent;
      var featured = thumbs.find(function (thumb) {
        return option.dataset.mediaId && thumb.dataset.mediaId === option.dataset.mediaId;
      });
      var matches = thumbs.filter(function (thumb) {
        return mediaMatchesVariant(thumb.dataset.mediaSearch || '', variantTitle);
      });
      var shared = thumbs.filter(function (thumb) {
        var hay = normalize(thumb.dataset.mediaSearch || '');
        var setupSpecific = /(^|\s)(2|two|double|4|four)(\s|$)/.test(hay) ||
          /ready to fish|rigged and ready|without hook|no hook|unrigged|diy|hi lo|high low|complete surf rig/.test(hay);
        var detailView = /side profile|profile|rear|scent chamber|close up|closeup/.test(hay) ||
          (hay.indexOf('single') !== -1 && hay.indexOf('rig') === -1);
        return detailView || !setupSpecific;
      });
      if (matches.length) {
        thumbs.forEach(function (thumb) {
          thumb.hidden = matches.indexOf(thumb) === -1 && shared.indexOf(thumb) === -1 && thumb !== featured;
        });
        if (hint) hint.hidden = true;
        activate(featured || matches[0]);
      } else {
        thumbs.forEach(function (thumb) { thumb.hidden = false; });
        if (hint) hint.hidden = true;
        if (featured) activate(featured);
      }
    };
  }

  function initProduct(root) {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';
    var updateGallery = initProductGallery(root);
    var select = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    var comparePrice = root.querySelector('[data-product-compare-price]');
    var quantity = root.querySelector('[data-product-quantity]');
    var button = root.querySelector('[data-product-submit]');
    var buttonLabel = root.querySelector('[data-add-label]');
    var description = root.querySelector('[data-product-description]');
    var title = root.querySelector('.product-title');

    // Suppress only an exact repeated title inside the displayed description.
    // The original Shopify product description remains unchanged.
    if (description && title && description.firstElementChild &&
        /^(P|H1|H2|H3)$/.test(description.firstElementChild.tagName) &&
        normalize(description.firstElementChild.textContent) === normalize(title.textContent)) {
      description.firstElementChild.remove();
    }

    function updateVariant(updateUrl) {
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (button) {
        if (option.dataset.available === 'false') {
          button.disabled = true;
          button.dataset.themeUnavailable = 'true';
          if (buttonLabel) buttonLabel.textContent = 'Sold out';
        } else if (button.dataset.themeUnavailable === 'true') {
          // Do not unlock buttons disabled by an app when the theme didn't disable them.
          button.disabled = false;
          button.dataset.themeUnavailable = 'false';
          if (buttonLabel) buttonLabel.textContent = 'Add to cart';
        }
      }
      if (quantity) {
        var min = Number(option.dataset.quantityMin) || 1;
        var step = Number(option.dataset.quantityStep) || 1;
        var max = Number(option.dataset.quantityMax) || null;
        quantity.min = String(min);
        quantity.step = String(step);
        if (max !== null) quantity.max = String(max);
        else quantity.removeAttribute('max');
        var value = Number(quantity.value);
        if (!Number.isFinite(value) || value < min) value = min;
        value = min + Math.ceil((value - min) / step) * step;
        if (max !== null && value > max) value = min + Math.floor((max - min) / step) * step;
        quantity.value = String(value);
      }
      updateGallery(option);
      if (updateUrl && !(window.Shopify && window.Shopify.designMode)) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
    if (select) {
      select.addEventListener('change', function () { updateVariant(true); });
      updateVariant(false);
    }
  }

  function initialize(scope) {
    if (scope.matches && scope.matches('[data-product-section]')) initProduct(scope);
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-mobile-menu][open]').forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-menu][open]').forEach(function (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
})();
